import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { useAsync } from '@src/redux/hooks/useAsync';
import { clearTinRegistration, searchRegistrationStatus } from './actions';
import { SEARCH_REGISTRATION_STATUS } from './constants';

const tinRegistrationStatusSelector = (state) => {
  return state.tinStatus;
};

export const useTinRegistrationStatus = {
  state: () => {
    return useSelect(tinRegistrationStatusSelector);
  },
  actions: () => {
    return {
      searchRegistrationStatus: useAction(searchRegistrationStatus, {
        saga: useAsync(SEARCH_REGISTRATION_STATUS),
      }),
    };
  },
};

export const clearData = () => {
  return {
    clearRegistrationData: useAction(clearTinRegistration),
  };
};
